import React, { useState, useEffect, useContext } from 'react'
import classNames from 'classnames'
import Image from 'next/image'

const FieldInput = ({
  id = '',
  type = 'text',
  title = '',
  value = '',
  containerClassName = 'flex flex-col gap-1',
  fieldClass = '',
  customBorder = 'border-[#cbcbcb]',
  isErrorPresent = false,
  errorTitle = '',
  errorMsgClass = '',
  disabled = false,
  onChange = () => {},
  inputOnClick = () => {},
  readOnly = false,
  initialFocus = false,
  isPrefixIcon = false,
  inputClass = 'bg-white',
  onFocusLogging = null,
  ...rest
}) => {
  const [isFocused, setFocused] = useState(false)
  const [element, setElement] = useState(null)
  useEffect(() => {
    if (disabled) {
      setFocused(false)
    }
  }, [disabled])
  useEffect(() => {
    if (initialFocus && element) {
      element.focus()
    }
  }, [element])
  return (
    <div className={containerClassName}>
      <div
        className={classNames(
          'relative flex h-[48px] items-center rounded-sm border-solid font-noto-sans',
          fieldClass,
          isPrefixIcon ? 'pr-[16px]' : 'py-[4px] px-[16px]',
          !isFocused && !isErrorPresent && customBorder,
          isFocused ? 'border-[2px] border-[#0174D3]' : '',
          isErrorPresent ? 'border-[2px] border-[#dc2b49]' : '',
          disabled ? 'border border-greyPlaceholder300 bg-greyDisabledBackground50' : ''
        )}
      >
        {isPrefixIcon && (
          <div className="flex h-12 w-12 items-center justify-center">
            <Image
              src="/assets/ic_search.svg"
              alt="search"
              className="object-contain"
              height={24}
              width={24}
            />
          </div>
        )}
        <input
          id={id}
          autoComplete="off"
          ref={setElement}
          onChange={(event) => {
            onChange(id, event?.target?.value)
            inputOnClick(event?.target?.value)
          }}
          disabled={disabled}
          style={{ padding: 0, margin: 0 }}
          placeholder={!isFocused ? title : ''}
          onFocus={() => {
            if (!disabled && !readOnly) {
              setFocused(true)
              if (typeof onFocusLogging === 'function') {
                onFocusLogging()
              }
            }
          }}
          onBlur={() => {
            setFocused(false)
          }}
          readOnly={readOnly}
          className={classNames(
            'remove h-fit w-full items-center border-none text-base font-normal leading-[20px] text-title placeholder-[#666] outline-none',
            disabled ? 'bg-greyDisabledBackground50 text-[#989898]' : '',
            inputClass
          )}
          {...{ ...rest, type, value: value || '', id }}
        />
      </div>
      {isErrorPresent && (
        <div
          className={classNames(
            'font-noto-sans text-sm font-normal leading-18 text-[#dc2b49]',
            errorMsgClass
          )}
        >{`${errorTitle}`}</div>
      )}
    </div>
  )
}

export default FieldInput
